export default __webpack_public_path__ + "images/27a7cd6d8a7c9f88ad376e934f57069d-4_web_1919x543.webp";